import { Component, OnInit } from '@angular/core';
import { FuiBaseModal } from 'ngx-fomantic-ui';

export interface IConfirmModalContext {
  title: string;
  message: string;
}

@Component({
  selector: 'monorepo-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent implements OnInit {
  constructor(public modal: FuiBaseModal<IConfirmModalContext, void, void>) {}

  ngOnInit(): void {}
}
